(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller
  (:require
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

;;TODO fix
#_(defn highlight-figures-raw-data->editable-data
  [raw-data]
  {:columns ["Label" "Value" "Comment"]
   :data    raw-data
   :highlight-figures? true})

;;TODO fix
#_(defn highlight-figures-editable-data->raw-data
  [editable-data]
  (:data editable-data))

(defn block-table-raw-data->editable-data
  [raw-data]
  (let [columns [nil]]
    {:columns columns
     :block-table? true
     :original-data raw-data}))

(defn invest-europe-table-raw-data->editable-data
  [raw-data]
  {:original-data raw-data})

(defn invest-europe-editable-data->raw-data
  [edited-data _original]
  (let [original-data (:original-data edited-data)]
    (dissoc original-data :columns :highlight-figures?)))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name      (get-in report-data [:holding-name])
   :reference-date    (get-in report-data [:reference-date])
   :report-id         (:report-id props)
   :overview          {:case-overview   (report-ctl/rich-content
                                         props
                                         :case-overview-text)
                       :investment-info (->> (report-ctl/with-footnote
                                               props
                                               :investment-info-footnotes
                                               (:investment-info report-data))
                                             (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                                      :fixed-labels? true} props)
                                               :investment-info
                                               block-table-raw-data->editable-data
                                               invest-europe-editable-data->raw-data))}
   :highlight-figures (report-ctl/with-footnote
                        props
                        :highlight-figures-footnotes
                        (ov-ctl/figures (get-in report-data [:highlight-figures])))
   :revenue (->>
             (get-in report-data
                     [:revenue])
             (report-ctl/with-footnote
               props
               :revenue-footnotes)
             (report-ctl/with-editable-charts
               (merge {:multi-chart? true} props)
               :revenue
               multi-controller/multi-chart-ctl
               multi-controller/config->editable-data
               multi-controller/editable-data->raw-data))
   :headcount (->>
               (get-in report-data
                       [:headcount])
               (report-ctl/with-footnote
                 props
                 :headcount-footnotes)
               (report-ctl/with-editable-charts
                 (merge {:multi-chart? true} props)
                 :headcount
                 multi-controller/multi-chart-ctl
                 multi-controller/config->editable-data
                 multi-controller/editable-data->raw-data))
   :logo-image-1      (report-ctl/image-content
                       props
                       :logo-image-1-footnotes
                       (:logo-image-1 dynamic-data))})
